// extracted by mini-css-extract-plugin
module.exports = {"section":"PriceList_section__2VvzJ"};